import { Dispatcher } from './helpers/Dispatcher';
import { getCurrentBreakPoint } from './helpers/getCurrentBreakPoint';
import { checkIsDesktopBreakPoint } from './helpers/checkIsDesktopBreakPoint';
import { checkIsMobileBreakPoint } from './helpers/checkIsMobileBreakPoint';
import { BreakPointsKeys, SubscriberAttributes, ViewSizeControllerData, ViewSizeControllerSubscriber } from './types';
const ViewSizeControllerSymbol = Symbol('ViewSizeControllerSymbol');

/**
 * Контроллер размерности окна браузера,
 * реализует отслеживание resize на объекте window,
 * записывает текщее состояние и передаёт его в подписчиков
 */
export class ViewSizeController {
  dispatcherInstance = new Dispatcher();
  /**
   * Текущий брейкпоинт из списка `BreakPointsKeys`
   */
  _currentBreakPoint = getCurrentBreakPoint(typeof window !== 'undefined' ? window.innerWidth : 0);
  /**
   * `true`, если брейкпоинт нахождения в диапозоне `desktopViewBreakPoints`, иначе `false`
   */
  _isDesktop = checkIsDesktopBreakPoint(this._currentBreakPoint);
  /**
   * `true`, если брейкпоинт нахождения в диапозоне `mobileViewBreakPoints`, иначе `false`
   */
  _isMobile = checkIsMobileBreakPoint(this._currentBreakPoint);
  constructor(enforcer) {
    if (enforcer !== ViewSizeControllerSymbol) {
      throw new Error('Cannot construct singleton');
    }
  }

  /**
   * Экземпляр контроллера размерности окна браузера,
   * реализует отслеживание resize на объекте window,
   * записывает текщее состояние и передаёт его в подписчиков
   */
  static get instance() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!this[ViewSizeControllerSymbol]) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this[ViewSizeControllerSymbol] = new ViewSizeController(ViewSizeControllerSymbol);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        window.addEventListener('resize', this[ViewSizeControllerSymbol].handleWindowResize);
      }
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this[ViewSizeControllerSymbol];
  }

  /**
   * @returns - Текущий брейкпоинт из списка `BreakPointsKeys`
   */
  get currentBreakPoint() {
    return this._currentBreakPoint;
  }

  /**
   * @returns - `true`, если брейкпоинт нахождения в диапозоне `desktopViewBreakPoints`, иначе `false`
   */
  get isDesktop() {
    return this._isDesktop;
  }

  /**
   * @returns -  `true`, если брейкпоинт нахождения в диапозоне `mobileViewBreakPoints`, иначе `false`
   */
  get isMobile() {
    return this._isMobile;
  }

  /**
   * @returns - Возвращает текущее состояние контроллера
   */
  get viewSizeData() {
    return {
      currentBreakPoint: this.currentBreakPoint,
      isDesktop: this.isDesktop,
      isMobile: this.isMobile
    };
  }

  /**
   * Метод отправлеят изменения в подписчиков
   */
  updateSubscribers = () => {
    this.dispatcherInstance.dispatch(this.viewSizeData);
  };

  /**
   * Метод обрабатывает события resize
   */
  // @ts-ignore
  handleWindowResize = event => {
    const newBreakPoint = getCurrentBreakPoint(event.target.innerWidth);
    if (newBreakPoint !== this.currentBreakPoint) {
      this._currentBreakPoint = newBreakPoint;
      if (this.currentBreakPoint) {
        this._isDesktop = checkIsDesktopBreakPoint(this.currentBreakPoint);
        this._isMobile = checkIsMobileBreakPoint(this.currentBreakPoint);
      }
      this.updateSubscribers();
    }
  };
  subscribe = subscriber => {
    this.dispatcherInstance.subscribe(subscriber);
  };
  unsubscribe = subscriber => {
    this.dispatcherInstance.unsubscribe(subscriber);
  };
}